<template>
  <div class="pb-5">
    <div
      class="flex min-h-full flex-1 flex-col justify-center px-2 pt-12 lg:px-8"
    >
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          class="mx-auto"
          src="~assets/images/logo/dlto.svg"
          alt="deelotto"
          width="80"
          height="80"
        />
        <!-- <h2 class="text-center text-xl font-semibold leading-9">deelotto</h2> -->
        <h2
          class="mt-5 text-center text-2xl font-semibold leading-9 tracking-tight text-gray-900"
        >
          เข้าสู่ระบบ
        </h2>
      </div>
      <div
        class="mt-5 mx-auto w-full lg:max-w-lg shadow-lg rounded p-5 w-full border"
      >
        <form
          class="space-y-6"
          action="#"
          method="POST"
          @submit.prevent="signIn"
        >
          <div>
            <label
              for="username"
              class="block text-md font-medium leading-6 text-gray-900"
              >ชื่อผู้ใช้</label
            >
            <div class="mt-2">
              <input
                v-model.trim="loginData.username"
                required="required"
                type="text"
                name="username"
                id="username"
                class="block w-full rounded-md border-0 py-1.5 px-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-yellow-600 sm:text-md sm:leading-6"
              />
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between">
              <label
                for="password"
                class="block text-md font-medium leading-6 text-gray-900"
                >รหัสผ่าน</label
              >
            </div>
            <div class="mt-2">
              <input
                v-model.trim="loginData.password"
                @input="checkPasswordConfirm"
                required="required"
                type="password"
                name="password"
                id="password"
                autocomplete="current-password"
                class="block w-full rounded-md border-0 py-1.5 px-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-yellow-600 sm:text-md sm:leading-6"
              />
            </div>
          </div>
          <div>
            <small
              v-if="warningMessage"
              class="text-white text-center flex align-end justify-center shadow bg-red-600 p-1"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 mr-1"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
              {{ warningMessage }}</small
            >
          </div>

          <div class="columns-2">
            <NuxtLink to="/user/register">
              <GlobalsButtonRed ButtonType="button"
                >สมัครสมาชิก</GlobalsButtonRed
              >
            </NuxtLink>

            <GlobalsButtonYellow ButtonType="submit"
              >เข้าสู่ระบบ</GlobalsButtonYellow
            >
          </div>
          <div class="columns-1 text-right">
            <NuxtLink
              to="/user/forgetpassword"
              class="text-green-800 underline"
            >
              ลืมรหัสผ่าน
            </NuxtLink>
          </div>
        </form>
      </div>
    </div>
    <ResultLastest></ResultLastest>
    <ResultStock></ResultStock>
    <ResultLazyYeekeeShort
      slug="yeekee_5"
      tab="shortview"
      v-show="resultViewTypeYeekee5 === 'shortview'"
    ></ResultLazyYeekeeShort>
    <ResultLazyYeekeeLong
      slug="yeekee_5"
      tab="longview"
      v-show="resultViewTypeYeekee5 === 'longview'"
    ></ResultLazyYeekeeLong>
    <ResultLazyYeekeeShort
      slug="yeekee_15"
      tab="shortview"
      v-show="resultViewTypeYeekee15 === 'shortview'"
    ></ResultLazyYeekeeShort>
    <ResultLazyYeekeeLong
      slug="yeekee_15"
      tab="longview"
      v-show="resultViewTypeYeekee15 === 'longview'"
    ></ResultLazyYeekeeLong>
  </div>
</template>
<script setup>
import { set } from "@vueuse/core";
definePageMeta({
  layout: "login",
  middleware: ["already-auth"],
});
const loginData = ref({
  username: "",
  password: "",
});
const config = useRuntimeConfig();
const base_api = config.public.apiUri;
const resultViewTypeYeekee5 = useResultViewTypeYeekee5();
const resultViewTypeYeekee10 = useResultViewTypeYeekee10();
const resultViewTypeYeekee15 = useResultViewTypeYeekee15();
const warningMessage = ref("");
async function resetForm() {
  set(loginData, {
    username: "",
    password: "",
  });
}
const userStore = useUserStore();
const signIn = async () => {
  const res = await userStore.signIn({
    username: loginData.value.username,
    password: loginData.value.password,
  });
  if (res.token) {
    if (res.user.role === "user") {
      await navigateTo("/games", { replace: true });
    } else {
      userStore.setToken(null);
      userStore.setUser(null);
      userStore.setRefreshToken(null);
    }
  }
  if (res.error) {
    if (res.error == "pass wrong") {
      set(warningMessage, "รหัสผ่านไม่ถูกต้อง");
    }
    if (res.error == "not found username") {
      set(warningMessage, `ไม่พบชื่อบัญชี ${loginData.value.username} ในระบบ`);
    }
  }
};
</script>
<style scoped></style>
